import { createContext, useContext, ReactNode } from 'react';
import { useWebRTC } from '../hooks/useWebRTC';

type WebRTCContextType = ReturnType<typeof useWebRTC>;

const WebRTCContext = createContext<WebRTCContextType | null>(null);

export function WebRTCProvider({ children }: { children: ReactNode }) {
  const value = useWebRTC();
  return <WebRTCContext.Provider value={value}>{children}</WebRTCContext.Provider>;
}

export function useWebRTCContext(): WebRTCContextType {
  const ctx = useContext(WebRTCContext);
  if (!ctx) throw new Error('useWebRTCContext must be used inside WebRTCProvider');
  return ctx;
}
